module.exports = __webpack_public_path__ + "media/images/recruitment/designs/gamma-phi-design-1b9036fa4ba96c56b174701b5a90001d.svg";